import {
  Divider,
  EmptyState,
  ErrorBoundary,
  FieldSwitch,
  FlexBox,
} from '@dixa/lib-shared-habla';
import { Field } from 'redux-form';

import { FieldDescriptionWrapper } from 'components/settings/components/sections/dixaMessenger/views/appearance/components/generalSettings/components/FieldDescriptionWrapper';
import { messengerSettingsFormFields } from 'components/settings/components/sections/dixaMessenger/views/appearance/types';

import { SetPreviewLanguageFn } from '../../hooks/useMessengerPreview';

import { BulletinSettings } from './bulletinSettings';
import { LanguageSettings } from './languageSettings';

type GeneralSettingsProps = {
  setPreviewLanguage: SetPreviewLanguageFn;
};

export function GeneralSettings({
  setPreviewLanguage,
}: GeneralSettingsProps): JSX.Element {
  return (
    <FlexBox flexDirection="column" gap="500">
      <LanguageSettings setPreviewLanguage={setPreviewLanguage} />

      <Divider />

      <FieldDescriptionWrapper
        title={`Display the first word from agent's "Display name"`}
        description={`When this setting is enabled, only the first word of the agent's "Display name" will be shown in the widgets. If it's not enabled, the entire "Display name" will be displayed.`}
      >
        <Field
          name={messengerSettingsFormFields.agentDisplayNameFirstWord}
          component={FieldSwitch}
          type="checkbox"
        />
      </FieldDescriptionWrapper>

      <Divider />

      <FieldDescriptionWrapper
        title="Bulletin board"
        description="Share answers to your FAQs or let people know about discount codes.
            Add whatever content your audience might find helpful."
      >
        <Field
          name={messengerSettingsFormFields.bulletinBoardEnabled}
          component={FieldSwitch}
          type="checkbox"
        />
      </FieldDescriptionWrapper>

      <ErrorBoundary
        fallback={
          <EmptyState
            title="Something went wrong"
            description="An error occurred and this content couldn't be shown."
          />
        }
      >
        <BulletinSettings />
      </ErrorBoundary>
    </FlexBox>
  );
}
